// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Pause = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Pause = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Pause = _exports.Pause = function Pause(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.75977 2.5C4.34727 2.5 4.00977 2.8375 4.00977 3.25V16.75C4.00977 17.1625 4.34727 17.5 4.75977 17.5H7.00977C7.42227 17.5 7.75977 17.1625 7.75977 16.75V3.25C7.75977 2.8375 7.42227 2.5 7.00977 2.5H4.75977ZM2.50977 3.25C2.50977 2.00781 3.51758 1 4.75977 1H7.00977C8.25195 1 9.25977 2.00781 9.25977 3.25V16.75C9.25977 17.9922 8.25195 19 7.00977 19H4.75977C3.51758 19 2.50977 17.9922 2.50977 16.75V3.25ZM13.0098 2.5C12.5973 2.5 12.2598 2.8375 12.2598 3.25V16.75C12.2598 17.1625 12.5973 17.5 13.0098 17.5H15.2598C15.6723 17.5 16.0098 17.1625 16.0098 16.75V3.25C16.0098 2.8375 15.6723 2.5 15.2598 2.5H13.0098ZM10.7598 3.25C10.7598 2.00781 11.7676 1 13.0098 1H15.2598C16.502 1 17.5098 2.00781 17.5098 3.25V16.75C17.5098 17.9922 16.502 19 15.2598 19H13.0098C11.7676 19 10.7598 17.9922 10.7598 16.75V3.25Z",
      fill: "currentColor"
    }));
  };
});
